import { useEffect, useState } from 'react';
import { Option } from 'shared/types/general';
import { productWarehouseCostApi } from '../api/productWarehouseCostApi';
import { ProductWarehouseLinkMode } from '../types';

export const useProductWarehouseCostLinkOptions = (mode: ProductWarehouseLinkMode) => {
  const [options, setOptions] = useState<Option[]>([]);

  useEffect(() => {
    productWarehouseCostApi.getLinkOptions(mode).then(setOptions);
  }, [mode]);

  return { options };
};
